import { ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { ConditionalWrapper } from 'components/ConditionalWrapper';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

const MENU_FILL_SKELETON = 15;

type TMenuFillSkeletonProps = {
  withMenuWrapper?: boolean;
};

export const MenuFillSkeleton = ({
  withMenuWrapper = true
}: TMenuFillSkeletonProps): ReactElement => {
  return (
    <ConditionalWrapper
      condition={withMenuWrapper}
      wrapper={children => {
        return (
          <div
            className={cc([
              'menu-wrapper',
              {
                'menu-wrapper--mobile': isMobile()
              }
            ])}
          >
            {children}
          </div>
        );
      }}
    >
      <div className="menu-wrapper__container">
        {createArray(MENU_FILL_SKELETON).map(key => (
          <div
            key={key}
            className={cc([
              'menuItemFillSkeleton',
              { 'menuItemFillSkeleton--active': key === 0 },
              { 'menuItemFillSkeleton--mobile': isMobile() }
            ])}
          >
            <Skeleton.Avatar size={EIconSize._24} active />
          </div>
        ))}
      </div>
    </ConditionalWrapper>
  );
};
